module.exports = __webpack_public_path__ + "img/empreendimento-logo-23.6c2efebf.png";